import React from "react";
import { TradeList } from "../../../data/domestic/trades/types";
import {
  PaginationTable,
  PaginationDataProps,
} from "../../components/common/PagginationTable";
import { useTradeActions } from "./useTradeActions";
import { useTradeColumns } from "./useTradeColumns";
import { AccessRights } from "../../../core/navigation/types";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export interface TradeSumTableProps {
  userAccessRights: AccessRights;
  getData: () => void;
}

type TradeSumTablePropsType = TradeSumTableProps & PaginationDataProps<TradeList>;

const TradesSumTable: React.FunctionComponent<TradeSumTablePropsType> = ({
  userAccessRights,
  getData,
  ...tableProps
}) => {
  const actions = useTradeActions();
  const columns = useTradeColumns();

  const theme = useTheme();
  const screenExtraSmall = useMediaQuery(theme.breakpoints.only('xs'));

  return (
    <PaginationTable<TradeList>
      {...tableProps}
      getData={getData}
      //      immutableData={data}
      title=""
      columns={columns}
      actions={actions}
      options={{
//        actionsColumnIndex: -1,
				actionsColumnIndex: screenExtraSmall === true ? 0 : -1 ,
        search: false,
        toolbar: false,
      }}
    />
  );
};

export default TradesSumTable;
